var FilterOption = /** @class */ (function () {
    function FilterOption(obj, id) {
        if (id) {
            this.id = id;
        }
        this.value = obj.value;
        this.en_value = obj.en_value;
        this.filter_type = obj.filter_type;
    }
    Object.defineProperty(FilterOption.prototype, "Id", {
        get: function () {
            return this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterOption.prototype, "Value", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterOption.prototype, "Envalue", {
        get: function () {
            return this.en_value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterOption.prototype, "FilterType", {
        get: function () {
            return this.filter_type;
        },
        enumerable: false,
        configurable: true
    });
    return FilterOption;
}());
export { FilterOption };
export function createFilterOption(obj, id) {
    return new FilterOption(obj, id);
}
export function createFilterOptions(rawFilterOptions) {
    var filterOptions = [];
    var rawFilterOptionsData = rawFilterOptions.data;
    for (var _i = 0, rawFilterOptionsData_1 = rawFilterOptionsData; _i < rawFilterOptionsData_1.length; _i++) {
        var rawFilterOption = rawFilterOptionsData_1[_i];
        var filterOption = createFilterOption(rawFilterOption.attributes, rawFilterOption.id);
        filterOptions.push(filterOption);
    }
    return filterOptions;
}



//////////////////
// WEBPACK FOOTER
// ./src/classes/definitions/product/filterOption.ts
// module id = 117
// module chunks = 0